import {usePanorama} from '@wix/yoshi-flow-editor'
import {useMemo} from 'react'
import {createLogger} from '../services/logger'

export const useLogger = () => {
  const panoramaClient = usePanorama()

  const logger = useMemo(() => createLogger({panoramaClient}), [panoramaClient])

  return logger
}
